/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  Constants  */
const { hasData, getData, getFieldMap } = Response;
const endpoints = {
    client: '/note',
    community: '/communityNote',
    imported: '/importedNote',
    partner: '/partnerNote'
};

class Note {
    constructor(clientId) {
        this.requests = new Requests();
        this.clientId = clientId;
    }

    cancel = () => {
        this.requests.cancel();
    };

    get = async (p, options) => {
        const { endpoint, map } = options;

        const params = p;
        if (this.clientId) {
            params.platformTenantId = this.clientId;
            params.includeClients = true;
        }

        debug.dev('PARAMS', params);

        try {
            const response = await axios.get(endpoint, {
                cancelToken: this.requests.token(),
                params
            });
            if (!hasData(response)) {
                return map ? {} : [];
            }

            if (map) {
                return getFieldMap(response, 'applicationId', {
                    multiple: true
                });
            }

            return getData(response);
        } catch (e) {
            debug.e('Unable to get Client App Notes', e);
            return map ? {} : [];
        }
    };

    getAll = async (params, options = {}) =>
        this.get(
            { ...params, includeAll: true, size: -1, type: '*' },
            { ...options, endpoint: endpoints.client }
        );

    getClient = async (params, options = {}) =>
        this.get(
            { ...params, size: -1 },
            { ...options, endpoint: endpoints.client }
        );

    getPartner = async (params, options = {}) =>
        this.get(
            { ...params, size: -1 },
            { ...options, endpoint: endpoints.partner }
        );

    getCommunity = async (params, options = {}) =>
        this.get(
            { ...params, size: -1 },
            { ...options, endpoint: endpoints.community }
        );

    getImported = async (params, options = {}) =>
        this.get(
            { ...params, size: -1 },
            { ...options, endpoint: endpoints.imported }
        );
}

export default Note;
